// === LOADER — FILM TITLE CARD ===
  // Loader removed — show scroll rail immediately
  (function(){ var el = document.getElementById('scrollRail'); if (el) el.classList.add('show'); })();

  // === SCROLL RAIL — ACTIVE SECTION TRACKING ===
  const railItems = document.querySelectorAll('.rail-item');
  const sections = ['hero', 'shop', 'product-2', 'moment', 'product-3', 'final'];
  const sectionMap = {
    'hero': 'hero',
    'shop': 'shop',
    'product-2': 'product-2',
    'moment': 'moment',
    'product-3': 'product-3',
    'final': 'final'
  };

  const railObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio > 0.4) {
        const id = e.target.id;
        railItems.forEach(item => {
          item.classList.toggle('active', item.dataset.target === id);
        });
      }
    });
  }, { threshold: [0.4, 0.6] });
  sections.forEach(id => {
    const el = document.getElementById(id);
    if (el) railObserver.observe(el);
  });

  // === PAGE BG COLOR PER SECTION ===
  const bgMap = {
    'hero': '#ffffff',
    'shop': '#ffffff',
    'product-2': '#f4f1ec',
    'moment': '#0a0a0a',
    'product-3': '#f4f1ec',
    'final': '#ffffff'
  };
  const bgObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio > 0.5) {
        document.body.style.background = bgMap[e.target.id] || '#ffffff';
      }
    });
  }, { threshold: [0.5] });
  sections.forEach(id => {
    const el = document.getElementById(id);
    if (el) bgObserver.observe(el);
  });

  // === DROP BADGE — APPEAR AFTER HERO ===
  const dropBadge = document.getElementById('dropBadge');
  const heroEl = document.getElementById('hero');
  if (dropBadge && heroEl) {
    const badgeObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        dropBadge.classList.toggle('show', !e.isIntersecting);
      });
    }, { threshold: 0.3 });
    badgeObserver.observe(heroEl);
  }

  // === HERO VIDEO PARALLAX ===
  const heroWrap = document.querySelector('.hero-img-wrap');
  const traceWrap = document.getElementById('shopTraceWrap');
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    if (scrolled < window.innerHeight * 1.2) {
      const t = `translateY(${scrolled * 0.35}px)`;
      if (heroWrap) heroWrap.style.transform = t;
      if (traceWrap) traceWrap.style.transform = t;
    }
  }, { passive: true });

  // === SHOPPABLE POSE TRACKING ===
  (() => {
    const data = window.POSE_DATA;
    const video = document.querySelector('.hero-img');
    const canvas = document.getElementById('shopTrace');
    const hotzone = document.getElementById('shopHotzone');
    if (!data || !video || !canvas || !hotzone) return;

    const ctx = canvas.getContext('2d');
    const FRAMES = data.frames;
    const N = FRAMES.length;
    const PTS = data.pts;
    let isHover = false;
    let smoothPoly = null;

    // Spider-walk transition state
    const spiderCanvas = document.getElementById('spiderCanvas');
    const sCtx = spiderCanvas ? spiderCanvas.getContext('2d') : null;
    let isWalking = false;
    let walkStart = 0;
    let walkPoly = null;          // viewport-coord snapshot of outline
    let walkStartCx = 0, walkStartCy = 0;
    let walkStartDocCy = 0;       // start centroid in DOC coords
    let walkDestDocPt = [0, 0];   // document coords of landing centroid
    let destRectPts = null;       // hoodie outline points (DOC coords)
    let pointDepart = null;       // per-point delay for symbiote stagger
    let pointPhase = null;        // per-point phase offset for tendril sway
    let walkScrollStart = 0;      // page scroll at click time
    let walkScrollEnd = 0;        // page scroll target at landing
    const WALK_MS = 1300;

    function resizeSpider() {
      const dpr = window.devicePixelRatio || 1;
      spiderCanvas.width = window.innerWidth * dpr;
      spiderCanvas.height = window.innerHeight * dpr;
      sCtx.setTransform(1, 0, 0, 1, 0, 0);
      sCtx.scale(dpr, dpr);
    }

    // Map the pre-extracted hoodie silhouette (normalized 0..1) onto the
    // showcase image's bounding box, with index offset so the topmost point
    // of the hoodie aligns with the spider's topmost point.
    function hoodiePerimeterPoints(rect, n, indexOffset) {
      const src = window.HOODIE_OUTLINE;
      if (!src || !src.poly) return null;
      // Inset slightly so the outline sits crisp against the hoodie edge
      const inset = 4;
      const x = rect.left + inset;
      const y = rect.top + inset + window.scrollY; // DOC coords
      const w = rect.width - inset * 2;
      const h = rect.height - inset * 2;
      const flat = src.poly;
      const pts = new Array(n);
      for (let j = 0; j < n; j++) {
        const i = ((j - indexOffset) % n + n) % n;
        const nx = flat[i * 2];
        const ny = flat[i * 2 + 1];
        pts[j] = [x + nx * w, y + ny * h];
      }
      return pts;
    }

    // Skip the dead intro — find the first frame where she's detected
    // and start the video there. Loop back to it instead of frame 0.
    let startIdx = 0;
    for (let i = 0; i < N; i++) {
      if (FRAMES[i].length > 0) { startIdx = i; break; }
    }
    const startTime = Math.max(0, startIdx / data.fps - 0.05);

    const seekToStart = () => {
      try { video.currentTime = startTime; } catch (e) {}
    };
    if (video.readyState >= 1) seekToStart();
    else video.addEventListener('loadedmetadata', seekToStart, { once: true });

    let lastT = startTime;
    video.addEventListener('timeupdate', () => {
      // currentTime jumped backward → loop wrapped, re-seek past the empty intro
      if (video.currentTime < lastT - 0.5) {
        video.currentTime = startTime;
      }
      lastT = video.currentTime;
    });

    hotzone.addEventListener('mouseenter', () => isHover = true);
    hotzone.addEventListener('mouseleave', () => isHover = false);

    // Click → simple smooth scroll to the hoodie section. Venom transition removed.
    hotzone.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('shop') || document.querySelector('.showcase') || document.querySelector('main');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Curved bezier trajectory — arcs slightly off the straight line
    function bezierPos(prog, sx, sy, ex, ey) {
      const dx = ex - sx, dy = ey - sy;
      const dist = Math.sqrt(dx*dx + dy*dy) || 1;
      const nx = -dy / dist, ny = dx / dist;       // perpendicular
      const arc = -Math.min(dist * 0.16, 220);     // arc upward (negative y in screen)
      const cx = (sx + ex) / 2 + nx * arc;
      const cy = (sy + ey) / 2 + ny * arc;
      const omt = 1 - prog;
      return [
        omt*omt * sx + 2*omt*prog * cx + prog*prog * ex,
        omt*omt * sy + 2*omt*prog * cy + prog*prog * ey,
      ];
    }

    function drawShape(pts, offsetX, offsetY, alpha, lineWidth, blur) {
      sCtx.beginPath();
      const m0x = (pts[PTS-1][0] + pts[0][0]) / 2 + offsetX;
      const m0y = (pts[PTS-1][1] + pts[0][1]) / 2 + offsetY;
      sCtx.moveTo(m0x, m0y);
      for (let i = 0; i < PTS; i++) {
        const cx = pts[i][0] + offsetX, cy = pts[i][1] + offsetY;
        const nx = pts[(i+1)%PTS][0] + offsetX, ny = pts[(i+1)%PTS][1] + offsetY;
        sCtx.quadraticCurveTo(cx, cy, (cx + nx) / 2, (cy + ny) / 2);
      }
      sCtx.closePath();
      sCtx.strokeStyle = '#fff';
      sCtx.lineWidth = lineWidth;
      sCtx.shadowBlur = blur;
      sCtx.shadowColor = 'rgba(255,255,255,0.55)';
      sCtx.globalAlpha = alpha;
      sCtx.stroke();
      sCtx.globalAlpha = 1;
    }

    // Compute every polygon point's DOC-coord position at a given global progress.
    // Each point has its own staggered timeline → leading tendrils reach first,
    // trailing body mass follows. Each point's path bends + sways like Venom symbiote.
    function computeSymbiotePts(t, elapsedMs) {
      const out = new Array(PTS);
      for (let i = 0; i < PTS; i++) {
        const dep = pointDepart[i];
        const localT = Math.max(0, Math.min(1, (t - dep) / Math.max(0.001, 1 - dep)));
        // Strong ease-out: snaps forward like a whip
        const eased = 1 - Math.pow(1 - localT, 2.6);

        const startDocX = walkPoly[i][0];
        const startDocY = walkPoly[i][1] + (walkStartDocCy - walkStartCy);
        const endDocX = destRectPts[i][0];
        const endDocY = destRectPts[i][1];

        const dx = endDocX - startDocX;
        const dy = endDocY - startDocY;
        const dist = Math.sqrt(dx * dx + dy * dy) || 1;
        const nx = -dy / dist, ny = dx / dist;       // perpendicular to travel

        // Curved bezier per-point: control point arced perpendicular
        const arc = -Math.min(dist * 0.18, 200);
        const ctrlX = (startDocX + endDocX) / 2 + nx * arc;
        const ctrlY = (startDocY + endDocY) / 2 + ny * arc;
        const omt = 1 - eased;
        let docX = omt * omt * startDocX + 2 * omt * eased * ctrlX + eased * eased * endDocX;
        let docY = omt * omt * startDocY + 2 * omt * eased * ctrlY + eased * eased * endDocY;

        // Sinusoidal sway perpendicular to travel — tendril writhe.
        // Peaks during transit, dies at start and end.
        const writhePhase = pointPhase[i] + elapsedMs * 0.011;
        const writheAmp = Math.sin(localT * Math.PI) * 14;
        const sway = Math.sin(writhePhase) * writheAmp;
        docX += nx * sway;
        docY += ny * sway;

        out[i] = [docX, docY];
      }
      return out;
    }

    function spiderTick() {
      if (!isWalking) return;
      const elapsed = performance.now() - walkStart;
      const t = Math.min(elapsed / WALK_MS, 1);

      // SCROLL: glide on its own ease-out timeline matching the leading edge.
      // This decouples scroll from polygon-avg (which lagged because of stagger)
      // — now the page moves AS FAST as the front of the symbiote.
      const scrollEased = 1 - Math.pow(1 - t, 2.6);
      const desiredScroll = walkScrollStart + (walkScrollEnd - walkScrollStart) * scrollEased;
      const maxScrollNow = document.documentElement.scrollHeight - window.innerHeight;
      window.scrollTo(0, Math.max(window.scrollY, Math.min(desiredScroll, maxScrollNow)));

      // Now compute polygon (after scroll updates so coordinates are fresh)
      const ptsDoc = computeSymbiotePts(t, elapsed);
      const sy = window.scrollY;
      const ptsView = ptsDoc.map(p => [p[0], p[1] - sy]);

      sCtx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      sCtx.lineJoin = 'round';
      sCtx.lineCap = 'round';

      // SYMBIOTE TRAIL — re-evaluate the polygon at lagged time values for true trail
      const ghosts = [
        { lag: 0.18, alpha: 0.06, lw: 0.8, blur: 6 },
        { lag: 0.13, alpha: 0.10, lw: 1.0, blur: 9 },
        { lag: 0.085, alpha: 0.18, lw: 1.2, blur: 12 },
        { lag: 0.05, alpha: 0.30, lw: 1.5, blur: 16 },
        { lag: 0.025, alpha: 0.50, lw: 1.7, blur: 20 },
      ];
      for (const g of ghosts) {
        if (t - g.lag <= 0) continue;
        const ghostDoc = computeSymbiotePts(t - g.lag, elapsed - g.lag * WALK_MS);
        const ghostView = ghostDoc.map(p => [p[0], p[1] - sy]);
        drawShape(ghostView, 0, 0, g.alpha, g.lw, g.blur);
      }

      // Main outline — heavier glow during transit, brightens on landing
      const mainAlpha = 1;
      const transitGlow = 24 + Math.sin(t * Math.PI) * 12;
      drawShape(ptsView, 0, 0, mainAlpha, 2.0, transitGlow);

      if (t < 1) requestAnimationFrame(spiderTick);
    }
    window.addEventListener('resize', () => { if (isWalking) resizeSpider(); });

    function resize() {
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpr, dpr);
    }
    resize();
    window.addEventListener('resize', resize);

    function tick() {
      const rect = canvas.getBoundingClientRect();
      ctx.clearRect(0, 0, rect.width, rect.height);

      // While the spider is walking, the regular tracking canvas is hidden
      if (isWalking) { requestAnimationFrame(tick); return; }

      const t = video.currentTime % data.d;
      const fIdx = t * data.fps;
      const i0 = Math.floor(fIdx) % N;
      const i1 = (i0 + 1) % N;
      const frac = fIdx - Math.floor(fIdx);
      const f0 = FRAMES[i0];
      const f1 = FRAMES[i1];

      // Need both neighboring frames populated to interpolate
      if (!f0.length || !f1.length) {
        hotzone.style.display = 'none';
        canvas.classList.remove('live');
        smoothPoly = null;
        requestAnimationFrame(tick);
        return;
      }

      // object-fit: cover scaling
      const vAR = data.w / data.h;
      const eAR = rect.width / rect.height;
      let scale, ox = 0, oy = 0;
      if (eAR > vAR) {
        scale = rect.width / data.w;
        oy = (rect.height - data.h * scale) / 2;
      } else {
        scale = rect.height / data.h;
        ox = (rect.width - data.w * scale) / 2;
      }

      // Interpolate flat arrays between frames + map to canvas pixels
      const targetPts = new Array(PTS);
      for (let i = 0, k = 0; i < PTS; i++, k += 2) {
        const x = (f0[k]   + (f1[k]   - f0[k])   * frac) * data.w * scale + ox;
        const y = (f0[k+1] + (f1[k+1] - f0[k+1]) * frac) * data.h * scale + oy;
        targetPts[i] = [x, y];
      }

      // Extra easing across RAF ticks for buttery follow
      if (smoothPoly && smoothPoly.length === PTS) {
        for (let i = 0; i < PTS; i++) {
          smoothPoly[i][0] += (targetPts[i][0] - smoothPoly[i][0]) * 0.22;
          smoothPoly[i][1] += (targetPts[i][1] - smoothPoly[i][1]) * 0.22;
        }
      } else {
        smoothPoly = targetPts;
      }
      const pts = smoothPoly;

      // Smooth closed curve via quadratic beziers through midpoints
      ctx.beginPath();
      const m0x = (pts[PTS - 1][0] + pts[0][0]) / 2;
      const m0y = (pts[PTS - 1][1] + pts[0][1]) / 2;
      ctx.moveTo(m0x, m0y);
      for (let i = 0; i < PTS; i++) {
        const cur = pts[i];
        const nxt = pts[(i + 1) % PTS];
        ctx.quadraticCurveTo(cur[0], cur[1], (cur[0] + nxt[0]) / 2, (cur[1] + nxt[1]) / 2);
      }
      ctx.closePath();
      ctx.strokeStyle = isHover ? '#fff' : 'rgba(255,255,255,0.78)';
      ctx.lineWidth = isHover ? 2.4 : 1.6;
      ctx.shadowBlur = isHover ? 24 : 10;
      ctx.shadowColor = 'rgba(255,255,255,0.5)';
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.stroke();

      let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
      for (let i = 0; i < PTS; i++) {
        const p = pts[i];
        if (p[0] < minX) minX = p[0];
        if (p[0] > maxX) maxX = p[0];
        if (p[1] < minY) minY = p[1];
        if (p[1] > maxY) maxY = p[1];
      }
      hotzone.style.left = minX + 'px';
      hotzone.style.top = minY + 'px';
      hotzone.style.width = (maxX - minX) + 'px';
      hotzone.style.height = (maxY - minY) + 'px';
      hotzone.style.display = 'block';
      canvas.classList.add('live');

      requestAnimationFrame(tick);
    }
    tick();
  })();

  // === 3D TILT ON PRODUCT IMAGES ===
  document.querySelectorAll('.showcase-img').forEach(wrap => {
    wrap.addEventListener('mousemove', (e) => {
      wrap.classList.add('tilt');
      const rect = wrap.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      const rotX = y * -8;
      const rotY = x * 8;
      wrap.querySelectorAll('img').forEach(img => {
        img.style.transform = `perspective(1200px) rotateX(${rotX}deg) rotateY(${rotY}deg) scale(1.04)`;
      });
    });
    wrap.addEventListener('mouseleave', () => {
      wrap.classList.remove('tilt');
      wrap.querySelectorAll('img').forEach(img => {
        img.style.transform = '';
      });
    });
  });

  // === WORD-BY-WORD REVEAL ===
  const wordObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.querySelectorAll('.word-reveal').forEach(w => w.classList.add('in'));
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.moment').forEach(el => wordObserver.observe(el));

  // === CART DRAWER ===
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartClose = document.getElementById('cartClose');
  const cartShopBtn = document.getElementById('cartShopBtn');
  const navBag = document.getElementById('navBag');
  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
  }
  if (navBag) navBag.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartShopBtn) {
    cartShopBtn.addEventListener('click', (e) => {
      const targetUrl = cartShopBtn.getAttribute('href');
      const currentPath = window.location.pathname + window.location.search;
      const targetPath = new URL(targetUrl, window.location.origin).pathname;
      // If already on the target page, don't let the browser do a no-op navigation
      // that leaves the cart drawer visible. Close the drawer and scroll to products.
      if (targetPath === window.location.pathname) {
        e.preventDefault();
        closeCart();
        const firstShowcase = document.querySelector('.showcase');
        if (firstShowcase) {
          setTimeout(() => firstShowcase.scrollIntoView({ behavior: 'smooth', block: 'start' }), 250);
        }
      } else {
        closeCart();
        // let the link navigate normally
      }
    });
  }

  // === LOOKBOOK OVERLAY ===
  const lbOverlay = document.getElementById('lookbookOverlay');
  const navLookbook = document.getElementById('navLookbook');
  const lbClose = document.getElementById('lbClose');
  if (navLookbook && lbOverlay) {
    navLookbook.addEventListener('click', (e) => {
      e.preventDefault();
      lbOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (lbClose && lbOverlay) {
    lbClose.addEventListener('click', () => {
      lbOverlay.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // === GENERIC PAGE OVERLAYS (Contact / Tracking / Terms) ===
  function closeAllPageOverlays() {
    document.querySelectorAll('.page-overlay').forEach(o => o.classList.remove('open'));
  }
  // Open: any link with data-open="<overlayId>"
  document.querySelectorAll('[data-open]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const id = el.dataset.open;
      const ov = document.getElementById(id);
      if (!ov) return;
      // Close cart drawer if open (avoid stacking)
      if (cartDrawer) cartDrawer.classList.remove('open');
      if (cartOverlay) cartOverlay.classList.remove('open');
      // Close any other page overlay
      closeAllPageOverlays();
      // Close lookbook if it was open
      if (lbOverlay) lbOverlay.classList.remove('open');
      // Open requested
      ov.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });
  // Close: any button with data-close="<overlayId>"
  document.querySelectorAll('[data-close]').forEach(el => {
    el.addEventListener('click', () => {
      const id = el.dataset.close;
      const ov = document.getElementById(id);
      if (ov) ov.classList.remove('open');
      document.body.style.overflow = '';
    });
  });

  // === ESC TO CLOSE ANY OVERLAY ===
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      lbOverlay.classList.remove('open');
      closeAllPageOverlays();
      document.body.style.overflow = '';
    }
  });

  // === SPARKLE CURSOR ===
  const sparkle = document.getElementById('cursorSparkle');
  const sparkleLabel = document.getElementById('sparkleLabel');
  if (sparkle) {
    let mx = 0, my = 0, sx = 0, sy = 0, sInit = false;

    document.addEventListener('mousemove', (e) => {
      mx = e.clientX;
      my = e.clientY;
      if (!sInit) {
        sx = mx; sy = my;
        sparkle.style.opacity = '1';
        sInit = true;
      }
    });
    document.addEventListener('mouseleave', () => { sparkle.style.opacity = '0'; });
    document.addEventListener('mouseenter', () => { if (sInit) sparkle.style.opacity = '1'; });
    document.addEventListener('mousedown', () => sparkle.classList.add('click'));
    document.addEventListener('mouseup', () => sparkle.classList.remove('click'));

    function sparkleLoop() {
      sx += (mx - sx) * 0.28;
      sy += (my - sy) * 0.28;
      sparkle.style.transform = `translate3d(${sx}px, ${sy}px, 0) translate(-50%, -50%)`;
      requestAnimationFrame(sparkleLoop);
    }
    sparkleLoop();

    const labelMap = { view: 'View', add: 'Add', cart: 'Bag', shop: 'Shop' };
    document.querySelectorAll('a, button, [data-cursor], .product, .detail-tile, .showcase-img').forEach(el => {
      el.addEventListener('mouseenter', () => {
        sparkle.classList.add('grow');
        const tag = el.dataset.cursor;
        if (sparkleLabel) sparkleLabel.textContent = tag ? (labelMap[tag] || tag.toUpperCase()) : '';
      });
      el.addEventListener('mouseleave', () => {
        sparkle.classList.remove('grow');
        if (sparkleLabel) sparkleLabel.textContent = '';
      });
    });
  }

  // === NAV ON SCROLL ===
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    });
  }

  // === REVEAL ON SCROLL ===
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.reveal, .showcase').forEach(el => observer.observe(el));

  // === SIZE CHART UNIT TOGGLE (inches ↔ cm) — per chart pane ===
  document.querySelectorAll('.size-chart').forEach(chart => {
    const buttons = chart.querySelectorAll('.unit-btn');
    const cells = chart.querySelectorAll('td[data-in][data-cm]');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const unit = btn.dataset.unit;
        if (!unit) return;
        buttons.forEach(b => {
          const isActive = b === btn;
          b.classList.toggle('active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        cells.forEach(td => {
          td.textContent = td.dataset[unit] || td.textContent;
        });
      });
    });
  });

  // === SIZE CHART PRODUCT TABS (jacket / hoodie / pants) ===
  function showChartPane(targetKey) {
    if (!targetKey) return;
    document.querySelectorAll('.chart-tab').forEach(t => {
      const isActive = t.dataset.chartTab === targetKey;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    document.querySelectorAll('.size-chart[data-chart-pane]').forEach(pane => {
      const isActive = pane.dataset.chartPane === targetKey;
      pane.classList.toggle('active', isActive);
      if (isActive) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
    });
  }
  document.querySelectorAll('.chart-tab').forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      showChartPane(tab.dataset.chartTab);
    });
  });
  // When a "Size guide →" link is clicked, switch to its product's pane before the overlay opens.
  document.querySelectorAll('[data-open="sizeChartOverlay"][data-chart]').forEach(link => {
    link.addEventListener('click', () => {
      showChartPane(link.dataset.chart);
    });
  });

  // === SIZE PICKER (per product showcase) ===
  document.querySelectorAll('.showcase-sizes[data-size-picker]').forEach(picker => {
    const showcase = picker.closest('.showcase');
    if (!showcase) return;
    const form = showcase.querySelector('form[data-add-to-cart-form]');
    if (!form) return;
    const variantInput = form.querySelector('[data-variant-input]');
    const ctaBtn = form.querySelector('[data-cta-text]');
    if (!variantInput) return;

    function setSelected(pill) {
      if (!pill) return;
      const vid = pill.dataset.variantId;
      const price = pill.dataset.price;
      if (vid) variantInput.value = vid;
      picker.querySelectorAll('.size-pill').forEach(p => p.classList.remove('selected'));
      pill.classList.add('selected');
      if (ctaBtn && price) ctaBtn.textContent = 'Add to Bag — ' + price + ' →';
    }

    picker.querySelectorAll('.size-pill').forEach(pill => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (pill.disabled || pill.classList.contains('sold-out')) return;
        setSelected(pill);
      });
    });

    // Defensive: right before the form submits, re-sync the variant id from the currently selected pill.
    // This guarantees the cart receives the correct variant even if a click handler missed.
    form.addEventListener('submit', () => {
      const selected = picker.querySelector('.size-pill.selected');
      if (selected && selected.dataset.variantId) {
        variantInput.value = selected.dataset.variantId;
      }
    });
  });
